import { useTranslation } from 'react-i18next';
import { InfiosContainer, InfiosProgressSteps, InfiosProgressStepsItem, InfiosTextBlock } from '@infios/uikit/react';
import type { OrderTimelineData } from '../../interfaces/chat';
import { FormattedDateTime } from '../FormattedDateTime';
import { getStatusLabel } from './statusLabel';

interface OrderTimelineBlockProps {
  data: OrderTimelineData;
}

/** Position within the step sequence — determines end-cap rendering. */
function stepPosition(index: number, count: number): 'start' | 'middle' | 'end' {
  if (index === 0) return 'start';
  if (index === count - 1) return 'end';
  return 'middle';
}

export function OrderTimelineBlock({ data }: OrderTimelineBlockProps) {
  const { t } = useTranslation();
  const events = Array.isArray(data.events) ? data.events : [];
  if (events.length === 0) return null;

  return (
    <InfiosContainer type="card">
      <InfiosTextBlock slot="header" weight="bold">
        {t('ChatbotUI.OrderBlocks.TimelineHeading')}
      </InfiosTextBlock>

      <InfiosProgressSteps>
        {events.map((event, idx) => (
          <InfiosProgressStepsItem
            key={`${event.code ?? idx}-${event.timestamp ?? idx}`}
            position={stepPosition(idx, events.length)}
            status={idx === events.length - 1 ? 'current' : 'complete'}
          >
            <span slot="title">{getStatusLabel(event.code, t) || event.summary || '—'}</span>
            {event.timestamp ? (
              <span slot="subtitle">
                <FormattedDateTime iso={event.timestamp} />
              </span>
            ) : null}
          </InfiosProgressStepsItem>
        ))}
      </InfiosProgressSteps>

      {data.truncated ? <p>{t('ChatbotUI.OrderBlocks.TimelineTruncated')}</p> : null}
    </InfiosContainer>
  );
}
